import { usePurchaseCreateParts } from '@/core/domain/purchase/Purchase.hooks';
import { useReleasePurchaseFormContext } from '@/pages/MovementsPage/PurchasesPage/ReleasesPage/ReleasesPurchaseProvider';
import { Alert, Button } from 'antd';

export default function PurchaseItemsAlert() {
  const { itemsPurchase, purchase } = useReleasePurchaseFormContext();

  const hasItemsWithoutPartId = itemsPurchase?.some((item) => !item.partId);

  const purchaseCreateItems = usePurchaseCreateParts();

  const handleCreateParts = async () => {
    try {
      if (!purchase) return;

      await purchaseCreateItems.mutateAsync(purchase.id);
    } catch {}
  };

  if (!hasItemsWithoutPartId || !purchase?.proPartsComplementId) return null;

  return (
    <Alert
      style={{ marginTop: 24 }}
      type="warning"
      description={
        <>
          <p style={{ marginBottom: 0, fontSize: '1.2rem' }}>
            É necessário vincular todos os itens da compra a uma peça cadastrada
            no catálogo da oficina para realizar a movimentação de estoque
            corretamente.
          </p>

          <p>
            Vincule manualmente as peças na tela de itens, ou gere
            automaticamente e vincule abaixo.
          </p>

          <Button
            type="primary"
            onClick={handleCreateParts}
            loading={purchaseCreateItems.isLoading}
          >
            Gerar peças e vincular
          </Button>
        </>
      }
    />
  );
}
